import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useExcluirAtividade = ({ dataAndamento }) => {
  const {
    request: excluirRequest,
    data: excluirData,
    errors: excluirErrors,
    isLoading: excluirIsLoading,
  } = useApiClient();

  useEffect(() => {
    if (excluirIsLoading) return;

    if (!excluirData && !excluirErrors) return;

    if (excluirData) {
      toast.success("Atividade excluída com sucesso!");
      window.location.reload();
    }
  }, [excluirData, excluirErrors, excluirIsLoading]);

  const excluirAtividade = () => {
    excluirRequest(apiRoutes.fiscalizacao.prorrogacaoos.excluirAtividade, {
      sequencialPedidoProrrogacao: dataAndamento.sqPedidoProrrogacao,
      sequencialAndamento: dataAndamento.sequencialUltimoAndamento,
    });
  };

  return { excluirAtividade, excluirErrors, excluirIsLoading };
};

export default useExcluirAtividade;
